import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "@/app/App";
import "./index.css";
import { configureStorePresentation } from "@/app/state/store-presentation";

configureStorePresentation();

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
});

if (!import.meta.env.PROD) {
  document.title = `[${import.meta.env.MODE.toUpperCase()}] Integritty`;
}

createRoot(document.getElementById("root")!).render(<App />);
